/* eslint-disable import/prefer-default-export */
export const beneficiaryList = () => [
  'Spouse',
  'Child',
  'Father',
  'Mother',
  'Brother',
  'Sister',
];
